/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { ISecurityRequirementParent } from '../../core/models/common/ISecurityRequirementParent';
import { SecurityRequirement } from '../../core/models/common/SecurityRequirement';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * A command used to delete a single securityRequirement from an operation.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteSecurityRequirementCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _requirement : any;

    public _oldRequirement : any;

    public constructor(parent? : any, requirement? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.ISecurityRequirementParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.ISecurityRequirementParent") >= 0)) || parent === null) && ((requirement != null && requirement instanceof <any>SecurityRequirement) || requirement === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._requirement===undefined) this._requirement = null;
            if(this._oldRequirement===undefined) this._oldRequirement = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._requirement===undefined) this._requirement = null;
            if(this._oldRequirement===undefined) this._oldRequirement = null;
            (() => {
                this._parentPath = Library.createNodePath(<Node><any>parent);
                this._requirement = Library.writeNode(requirement);
            })();
        } else if(parent === undefined && requirement === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._requirement===undefined) this._requirement = null;
            if(this._oldRequirement===undefined) this._oldRequirement = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._requirement===undefined) this._requirement = null;
            if(this._oldRequirement===undefined) this._oldRequirement = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteSecurityRequirementCommand] Executing.");
        this._oldRequirement = null;
        let parent : ISecurityRequirementParent = <ISecurityRequirementParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let requirement : SecurityRequirement = parent.createSecurityRequirement();
        Library.readNode(this._requirement, requirement);
        let requirements : Array<SecurityRequirement> = parent.getSecurityRequirements();
        let idx : number = this.indexOfRequirement(requirements, requirement);
        if(idx !== -1) {
            this._oldRequirement = Library.writeNode(/* get */requirements[idx]);
            /* remove */requirements.splice(idx, 1)[0];
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteSecurityRequirementCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldRequirement)) {
            return;
        }
        let parent : ISecurityRequirementParent = <ISecurityRequirementParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let restoredRequirement : SecurityRequirement = parent.createSecurityRequirement();
        Library.readNode(this._oldRequirement, restoredRequirement);
        parent.addSecurityRequirement(restoredRequirement);
    }

    indexOfRequirement(requirements : Array<SecurityRequirement>, requirement : SecurityRequirement) : number {
        let idx : number = 0;
        for(let index132=0; index132 < requirements.length; index132++) {
            let r = requirements[index132];
            {
                if(this.isEqual(r, requirement)) {
                    return idx;
                }
                idx++;
            }
        }
        return -1;
    }

    isEqual(req1 : SecurityRequirement, req2 : SecurityRequirement) : boolean {
        let names1 : Array<string> = req1.getSecurityRequirementNames();
        let names2 : Array<string> = req2.getSecurityRequirementNames();
        if(/* size */(<number>names1.length) !== /* size */(<number>names2.length)) {
            return false;
        }
        let rval : boolean = true;
        for(let index133=0; index133 < names1.length; index133++) {
            let name1 = names1[index133];
            {
                if(names2.indexOf(name1) === -1 || !this.areScopesEqual(req1.getScopes(name1), req2.getScopes(name1))) {
                    rval = false;
                }
            }
        }
        return rval;
    }

    areScopesEqual(scopes1 : Array<string>, scopes2 : Array<string>) : boolean {
        if(/* size */(<number>scopes1.length) !== /* size */(<number>scopes2.length)) {
            return false;
        }
        let rval : boolean = true;
        for(let index134=0; index134 < scopes1.length; index134++) {
            let scope1 = scopes1[index134];
            {
                if(scopes2.indexOf(scope1) === -1) {
                    rval = false;
                }
            }
        }
        return rval;
    }
}
DeleteSecurityRequirementCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteSecurityRequirementCommand";
DeleteSecurityRequirementCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




